import React, { PureComponent } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Checkbox, Input, Select, Row, Col } from 'antd';
import { func, object } from 'prop-types';
import intl from 'react-intl-universal';
import ColorPicker from '../../Watermark/ColorPicker';
import AutoFlipConfigs, { validator, defaultValue } from './AutoFlipConfigs';
import { transitionNameMap, transitionDirectionMap } from '../../constants/index';
import './FullScreen.form.scss';

const { Item: FormItem } = Form;
const { Option } = Select;
const defaultFullScreenValue = {
  showScrollBar: true,
  showStatusBar: false,
  showNavigationPanels: false,
  showExitButton: true,
  showTheWholePage: true,
  mouseClickToScroll: true,
  loopScroll: false,
  autoFlip: defaultValue,
  color: '#000000',
  ignoreTransition: false,
  transitionName: '',
  direction: '',
  isNavigationControl: true,
};
class FormFullScreen extends PureComponent {
  static propTypes = {
    value: object,
    onChange: func,
    onError: func,
  }

  constructor(props) {
    super(props);
    this.handleColorChanged = this.handleColorChanged.bind(this);
    this.handleConfigChange = this.handleConfigChange.bind(this);
    this.handlTransitionNameChange = this.handlTransitionNameChange.bind(this);
  }

  handleColorChanged({ color }) {
    const { form: { setFieldsValue } } = this.props;
    setFieldsValue({ color });
  }
  handlTransitionNameChange(val) {
    const { form: { setFieldsValue } } = this.props;
    const directions = transitionDirectionMap[val] || [];
    setFieldsValue({ direction: directions.length > 0 ? '0' : '' });
  }
  handleConfigChange({ seconds }) {
    const { onError } = this.props;
    validator.validate({ seconds }).then(() => {
      onError(null);
    }).catch(({ errors }) => {
      onError(errors);
    })
  }

  render() {
    const {
      form: { getFieldDecorator }, 
      value: {
        showScrollBar, 
        showStatusBar, 
        showNavigationPanels, 
        showExitButton,
        showTheWholePage, 
        mouseClickToScroll, 
        loopScroll, 
        autoFlip, 
        color,
        ignoreTransition,
        transitionName,
        direction,
        isNavigationControl,
      } = defaultFullScreenValue,
    } = this.props;
    const directions = transitionDirectionMap[transitionName] ? transitionDirectionMap[transitionName] : []
    return <div className="form-full-screen">
            <Form layout="horizontal">
              <h2>{intl.get('Preferences.Content.FullScreen.Navigation')}</h2>
              <div className="form-full-screen-content">
                <FormItem wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('showScrollBar', {
                    initialValue: showScrollBar,
                    valuePropName: 'checked',
                  })(<Checkbox>{intl.get('Preferences.Content.FullScreen.ShowScrollBar')}</Checkbox>)}
                </FormItem>
                <FormItem wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('showStatusBar', {
                    initialValue: showStatusBar,
                    valuePropName: 'checked',
                  })(<Checkbox>{intl.get('Preferences.Content.FullScreen.ShowStatusBar')}</Checkbox>)}
                </FormItem>
                <FormItem wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('showNavigationPanels', {
                    initialValue: showNavigationPanels,
                    valuePropName: 'checked',
                  })(<Checkbox>{intl.get('Preferences.Content.FullScreen.ShowNavigationPanels')}</Checkbox>)}
                </FormItem>
                <FormItem wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('showExitButton', {
                    initialValue: showExitButton,
                    valuePropName: 'checked',
                  })(<Checkbox>{intl.get('Preferences.Content.FullScreen.ShowExitButton')}</Checkbox>)}
                </FormItem>
                <FormItem wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('showTheWholePage', {
                    initialValue: showTheWholePage,
                    valuePropName: 'checked',
                  })(<Checkbox>{intl.get('Preferences.Content.FullScreen.showTheWholePage')}</Checkbox>)}
                </FormItem>
                <FormItem wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('mouseClickToScroll', {
                    initialValue: mouseClickToScroll,
                    valuePropName: 'checked',
                  })(<Checkbox>{intl.get('Preferences.Content.FullScreen.MouseClickToScroll')}</Checkbox>)}
                </FormItem>
                <FormItem wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('loopScroll', {
                    initialValue: loopScroll,
                    valuePropName: 'checked',
                  })(<Checkbox>
                    {intl.get('Preferences.Content.FullScreen.LoopScroll')}
                  </Checkbox>)}
                </FormItem>
                <FormItem layout="inline" wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('autoFlip', {
                    initialValue: autoFlip,
                    rules: [{
                      validator: (rule, value, callback) => {
                        const { shouldAutoFlip, seconds } = value;
                        if (shouldAutoFlip) {
                          validator.validate({ seconds }).catch(({ errors }) => {
                            if (errors && errors[0]) {
                              callback(errors[0].message)
                            } else {
                              callback();
                            }
                          })
                        } else {
                          callback();
                        }
                      }
                    }],
                  })(<AutoFlipConfigs onChange={this.handleConfigChange} />)}
                </FormItem>
                <FormItem className="fv__hidden" layout="inline" wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('color', { initialValue: color })(<Input />)}
                </FormItem>
              </div>
              <h2>{intl.get('Preferences.Content.FullScreen.Appearance')}</h2>
              <div className="form-full-screen-content">
                <div className="color-picker">
                  <div className="color-picker-label">{intl.get('Preferences.Content.FullScreen.Background')}</div>
                  <ColorPicker key={color} color={color} onChangeComplete={this.handleColorChanged} />
                </div>
              </div>
              <h2>{intl.get('Preferences.Content.FullScreen.fullScreenTransitions')}</h2>
              <div className="form-full-screen-content">
                <FormItem wrapperCol={{ span: 24 }}>
                  {getFieldDecorator('ignoreTransition', {
                    initialValue: ignoreTransition,
                    valuePropName: 'checked',
                  })(<Checkbox>{intl.get('Preferences.Content.FullScreen.ignoreAllTransitions')}</Checkbox>)}
                </FormItem>
                <FormItem wrapperCol={{ span: 8 }} labelCol ={{ span: 7 }} label={intl.get('Preferences.Content.FullScreen.defaultTransition')}>
                  {getFieldDecorator('transitionName', {
                    initialValue: transitionName,
                  })(<Select size="small" style={{width:"150px"}} disabled={ignoreTransition} onChange={this.handlTransitionNameChange}>
                      {
                        transitionNameMap.map(item => <Option value={item.value} key={item.value}>{intl.get(`Preferences.Content.FullScreen.transitions.${item.name}`)}</Option>)
                      }
                    </Select>
                  )}
                </FormItem>
                <Row gutter={0}>
                  <Col span={14}>
                    <FormItem wrapperCol={{ span: 12 }} labelCol ={{ span: 12 }} label={intl.get('Preferences.Content.FullScreen.direction')}>
                      {getFieldDecorator('direction', {
                        initialValue: direction,
                      })(<Select size="small" style={{width:"150px"}} disabled={ ignoreTransition || directions.length === 0 }>
                          {
                            directions.map(item => <Option value={item.value} key={item.value}>{intl.get(`Preferences.Content.FullScreen.transitions.${item.name}`)}</Option>)
                          }
                        </Select>
                      )}
                    </FormItem>
                  </Col>
                  <Col span={10} style={{marginTop: "3px"}}>
                    <FormItem wrapperCol={{ span: 24 }}>
                      {getFieldDecorator('isNavigationControl', {
                        initialValue: isNavigationControl,
                        valuePropName: 'checked',
                      })(<Checkbox disabled={ignoreTransition || directions.length === 0 }>{intl.get('Preferences.Content.FullScreen.navigationControlDirenction')}</Checkbox>)}
                    </FormItem>
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
  }
}

const WrappedFormFullScreen = Form.create({
  name: 'FormFullScreen', onValuesChange: (props, changedValues, allValues) => {
    props.onSubmit(allValues);
  }
})(FormFullScreen);

export default WrappedFormFullScreen;
export { defaultFullScreenValue as defaultValue };
